import MessageBox from "./messageBox";
import AdminTitle from "./adminTitle";
import TableDataFilter from "./table_data_filter";
import TableDataFilterRadio from "./table_data_filter_radio";
import BreadCrumb from "./bread_crumb";
import HeadImg from "./head_img";
import HeadImg2 from "./head_img2";
import MyRadio from "./radio/index.js";
import UserInfo from "./user_info";
import BaseInput from "./base-input";
import BaseTextarea from "./base-textarea";
import ImagePreview from "./image-preview";
import BaseIcon from "./base-icon";
import MyWarning from "./warning";
import AllChoosed from "./all-choosed";
import InputSearch from './input-search';
import SgDatePicker from './date-picker'
let components = {
  MessageBox,
  AdminTitle,
  TableDataFilter,
  TableDataFilterRadio,
  BreadCrumb,
  HeadImg,
  HeadImg2,
  MyRadio,
  UserInfo,
  BaseInput,
  BaseTextarea,
  ImagePreview,
  BaseIcon,
  MyWarning,
  AllChoosed,
  InputSearch,
  SgDatePicker,
};

export default {
  install: function(Vue) {
    for (let i in components) {
      components[i].install(Vue);
    }
  },
};
